function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Instagram"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fill: "#6e6e6f",
  d: "M16.922 2.748c4.572 0 5.182 0 7.011.152 4.572.3 6.706 2.438 7.011 7.011a68.891 68.891 0 0 1 .152 7.011c0 4.572 0 5.182-.152 7.011-.152 4.572-2.439 6.858-7.011 7.011a68.9 68.9 0 0 1-7.011.152c-4.572 0-5.182 0-7.011-.152-4.572-.3-6.706-2.438-7.011-7.011 0-1.829-.152-2.438-.152-7.011s0-5.182.152-7.011C3.2 5.339 5.339 3.205 9.911 2.9c1.829 0 2.439-.152 7.011-.152zm0-3.048c-4.725 0-5.182 0-7.163.152C3.51.157.157 3.51-.148 9.759-.3 11.74-.3 12.2-.3 16.922s0 5.334.152 7.163c.3 6.249 3.658 9.6 9.907 9.906 1.829.152 2.439.152 7.163.152s5.334 0 7.163-.152c6.249-.3 9.754-3.81 10.059-10.059.152-1.829.152-2.438.152-7.163s0-5.182-.152-7.163c-.457-5.943-3.81-9.449-10.059-9.754C22.256-.3 21.647-.3 16.922-.3zm0 8.382a8.839 8.839 0 1 0 8.84 8.839 8.846 8.846 0 0 0-8.84-8.839zm0 14.631a5.791 5.791 0 1 1 5.791-5.791 5.789 5.789 0 0 1-5.791 5.791zm9.145-17.069a2.18 2.18 0 0 0-2.134 2.134 2.084 2.084 0 0 0 2.134 2.134A2.18 2.18 0 0 0 28.2 7.777a2.084 2.084 0 0 0-2.133-2.133z",
  transform: "translate(.3 .3)"
}));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Social-Icon-Instagram",
    width: 34.597,
    height: 34.443,
    viewBox: "0 0 34.597 34.443",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.3f4ff5e9.svg";
export { ForwardRef as ReactComponent };